import React from 'react';
import { animated, useSprings } from 'react-spring';

const Firework: React.FC = () => {
    const [springs, api] = useSprings(60, i => ({
        opacity: 1,
        transform: `translate(${Math.random() * 1200 - 600}px, ${Math.random() * 1000 - 500}px)`,
        config: { duration: 3500 },
    }));

    React.useEffect(() => {
        api.start(i => ({
            opacity: 0,
            transform: `translate(${Math.random() * 1000 - 500}px, ${Math.random() * 800 - 400}px)`,
        }));
    }, [api]);

    return (
        <div style={{
            display: 'flex',
            position: 'fixed',
            overflow: 'visible',
            backgroundColor: 'transparent',
            pointerEvents: 'none',
            zIndex: 1,
            width: '100vw',
            height: '100vh',
            top: 0,
            left: 0,
        }}>
            {springs.map((spring, i) => (
                <animated.div
                    key={i}
                    style={{
                        position: 'absolute',
                        width: '4px',
                        height: '4px',
                        backgroundColor: 'black',
                        borderRadius: '50%',
                        opacity: spring.opacity,
                        transform: spring.transform,
                        transformOrigin: 'center',
                        top: '50%',
                        left: '50%',
                    }}
                />
            ))}
        </div>
    );
};

export default Firework;
